import { oc } from "@orpc/contract";
import { z } from "zod";

/**
 * Task Count Schema - a single task count item
 */
export const TaskCountSchema = z.object({
  taskId: z.string(),
  count: z.number(),
});

/**
 * Get Task Counts Output Schema
 */
export const GetTaskCountsOutputSchema = z.object({
  counts: z.array(TaskCountSchema),
});

/**
 * Home Tasks Contracts
 */
export const homeTasksContracts = {
  getTaskCounts: oc.output(GetTaskCountsOutputSchema).route({
    method: "GET",
    path: "/home/task-counts",
  }),
} as const;

// Export types
export type TaskCount = z.infer<typeof TaskCountSchema>;
export type GetTaskCountsOutput = z.infer<typeof GetTaskCountsOutputSchema>;
